module.exports = __webpack_public_path__ + "img/GlobeChekWelcome.e994ee93.png";